<template lang="pug">
v-card(:class="[animate ? 'gelatine' : '']" height="auto" :id="`estate-${estate.codigo}`")
  div(class="d-flex")
    v-avatar(tile :color="selectedColor")
        v-icon(dark) mdi-home-circle
    v-list-item
      v-list-item-content
        v-list-item-title {{ estate.fmi }}
        v-list-item-subtitle {{ estate.codigo }}
    v-chip(
      small
      color="blue-grey"
      class="adjoining-item-key"
      label)
      b {{ estate.key }}
    //- btn(icon)
    //-     v-icon mdi-dots-vertical
  v-row(class="px-1" justify="space-between")
    v-col(v-if="estate.fmi" cols="4")
      folio-checker(
        :short-text="true"
        :folio-id="estate.folio_id"
        :folio-number="estate.fmi"
        :other-tab="true")
    v-col(cols="4")
      v-menu(offset-y)
        template(v-slot:activator="{ on, attrs }")
          v-btn(
            outlined
            title="Marcar predio en el mapa"
            small
            v-bind="attrs"
            v-on="on"
            :color="selectedColor")
            v-icon mdi-map-marker-down
            | Marcar
        v-color-picker(
          v-model="selectedColor"
          hide-inputs
          hide-sliders
          hide-canvas
          class="ma-2"
          :swatches="swatches"
          show-swatches)
    v-col(cols="4")
      v-menu(
        top
        offset-y
        ref="folioMenu"
        transition="slide-y-transition"
        :nudge-top="5"
        :close-on-content-click="false")
        template(v-slot:activator="{ on, attrs }")
          v-btn(
            outlined
            title="Otras opciones"
            small
            color="primary"
            v-bind="attrs"
            v-on="on")
            v-icon mdi-hammer-wrench
            | Mas
        v-list(dense)
          v-subheader(class="text-h6")
            | Folio: <b class="ml-2">{{ estate.fmi ? estate.fmi : 'Sin FMI' }}</b>
          v-divider
          v-list-item-group
            v-list-item(
              :disabled="estate.fmi === null"
              @click="generateFamily(estate.fmi)")
              v-list-item-icon
                v-icon(:disabled="estate.fmi === null || estate.fmi === ''" color="green") mdi-family-tree
              v-list-item-content
                v-list-item-title Familia Registral
            v-list-item(
              :disabled="estate.fmi === null"
              @click="adjacencySearch('code', estate.codigo)"
              title="Permite encontrar los predios colindantes")
              v-list-item-icon
                v-icon(:disabled="estate.fmi === null" color="pink") mdi-land-plots-circle
              v-list-item-content
                v-list-item-title Colindancia catastral
            v-list-item(
              :disabled="estate.folio_id === null"
              @click="showBotttomPdf(estate.url_archivo, estate.fmi)")
              v-list-item-icon
                v-icon(:disabled="estate.folio_id === null" color="red") mdi-file-pdf-box
              v-list-item-content
                v-list-item-title Ver PDF
            v-list-item(
              :disabled="estate.folio_id === null"
              @click="downloadPdf(estate.url_archivo, estate.fmi)")
              v-list-item-icon
                v-icon(:disabled="estate.folio_id === null" color="red") mdi-file-download
              v-list-item-content
                v-list-item-title Descargar PDF
            v-list-item(
              @click="syncFolio"
              :disabled="synchronizing || estate.fmi === null"
              title="Permite actualizar la información del folio")
              v-list-item-icon
                v-icon(:disabled="estate.fmi === null || estate.fmi === ''" color="purple") mdi-sync-circle
              v-list-item-content
                v-list-item-title
                  | {{ synchronizing ? 'Sincronizando...' : 'Sincronizar Folio'}}
    v-row(class="pb-2" v-if="horizontal")
      v-col
        v-list-item
          v-list-item-content
            v-list-item-title Linderos
            v-list-item-subtitle(
              style="white-space: normal"
              v-if="estate.cabida !== null") {{ estate.cabida }}
            v-list-item-subtitle(class="red--text" v-else) Folio NO encontrado
      v-divider(inset vertical)
      v-col
        v-list-item
          v-list-item-content
            v-list-item-title Complementaciones
            v-list-item-subtitle(
              style="white-space: normal"
              v-if="estate.complementacion !== null") {{ estate.complementacion }}
            v-list-item-subtitle(class="red--text" v-else) Folio NO encontrado
  v-card-actions(v-if="!horizontal")
    v-btn(color="orange lighten-2" text)
      | Otros Datos
    v-spacer
    v-btn(icon @click="show = !show")
      v-icon {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
  v-expand-transition
    div(v-show="show")
      v-divider
      v-list-item
        v-list-item-content
          v-list-item-title Linderos
          v-list-item-subtitle(
            style="white-space: normal"
            v-if="estate.cabida !== null") {{ estate.cabida }}
          v-list-item-subtitle(class="red--text" v-else) Folio NO encontrado
      v-list-item
        v-list-item-content
          v-list-item-title Complementaciones
          v-list-item-subtitle(
            style="white-space: normal"
            v-if="estate.complementacion !== null") {{ estate.complementacion }}
          v-list-item-subtitle(class="red--text" v-else) Folio NO encontrado
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import FolioChecker from '@/components/folios/FolioChecker.vue';
import folioMixin from '@/mixins/folioMixin.js';

export default {
  name: 'CadastralAjoiningItem',

  components: {
    FolioChecker,
  },

  mixins: [folioMixin],

  props: {
    // objeto con los datos del predio
    estate: {
      type: Object,
      required: true
    },
    // paleta de colores
    swatches: [
      ['#F44336', '#EF5350', '#B71C1C', '#E91E63', '#EC407A', '#880E4F'],
      ['#9C27B0', '#AB47BC', '#4A148C', '#3F51B5', '#5C6BC0', '#1A237E'],
      ['#2196F3', '#42A5F5', '#0D47A1', '#00BCD4', '#26C6DA', '#006064'],
      ['#009688', '#26A69A', '#004D40', '#4CAF50', '#66BB6A', '#1B5E20'],
      ['#8BC34A', '#9CCC65', '#33691E', '#CDDC39', '#D4E157', '#827717'],
      ['#FF9800', '#FFA726', '#E65100', '#795548', '#8D6E63', '#3E2723'],
      ['#607D8B', '#78909C', '#263238', '#9E9E9E', '#616161', '#000000'], // '#BDBDBD',
    ],
    // propuedad para mostrar los datos adicionales en horizontal
    horizontal: {
      type: Boolean,
      default: false
    },
    // propiedad para indicar si animar el elemento
    animate: {
      type: Boolean,
      default: false
    }
  },

  emits: [],

  data() {
    return {
      show: false,
      // propiedad que indica que le folio se esta sincronizando
      synchronizing: false,
    };
  },

  computed: {
    ...mapState('module', []),
    selectedColor: {
      get() {
        return this.estate.color;
      },
      set(value) {
        if (value === '#FFEEF0FF') return;
        this.UPDATE_GEOJSON_COLOR({
          npn: this.estate.codigo,
          color: value
        });
      }
    }
  },

  mounted() {},

  methods: {
    ...mapMutations('cadastral', [
      'UPDATE_GEOJSON_COLOR',
      'UPDATE_ADJOINING_DATA'
    ]),
    ...mapActions('cadastral', ['syncAdjoiningFolio']),
    // metodo para sincronizar el folio sin ercarga completa de la pagina
    async syncFolio() {
      this.synchronizing = true;
      const res = await this.syncAdjoiningFolio({
        fmi: this.estate.fmi,
        codigo: this.estate.codigo,
        codigo_ant: this.estate.codigo_ant
      });
      if (res) {
        this.UPDATE_GEOJSON_COLOR({
          npn: this.estate.codigo,
          color: res.color
        });
        this.UPDATE_ADJOINING_DATA({
          npn: this.estate.codigo, 
          data: res
        });
      }
      this.synchronizing = false;
    }
  }
};
</script>

<style scoped>
.adjoining-item-key {
  position: absolute;
  right: 0;
  text-shadow:
    -1px -1px 0 white,
     1px -1px 0 white,
    -1px  1px 0 white,
     1px  1px 0 white;
  font-size: large;
}
</style>
